import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { LogEmail } from 'crono-fe-common/types/logEmail';

export default function useGetLogEmail(
  id: number | null | undefined,
  enabled = true,
) {
  const request: Request = {
    url: `${ENDPOINTS.events.email}?${queryString.stringify({ id })}`,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.events.email, id],
    queryFn: () => client(request),
    staleTime: 5 * 60 * 1000,
    enabled: enabled && id != null,
  };

  const { data, isInitialLoading } = useQuery<
    Response<LogEmail | null>,
    CronoError
  >(requestConfig);

  return { data, isInitialLoading };
}
